import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appLink',
  label: 'External Links WLP',
  isDragable: true,
  canChangePosition: true,
  sortingPositionIndex: 'sortingIndex',
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  isMultiSelectable: false,
  emptyMessage: "You don't have external links, click on the \"+\" icon to create one.",
  newButton: false,
  createURL: 'mainHubId/configId/wlpExternalLinks',
  getURL: 'mainHubId/configId/wlpExternalLinks',
  updateURL: 'mainHubId/configId/wlpExternalLinks',
  removeURL: 'mainHubId/configId/wlpExternalLinks',
  sessionParams: ['mainHubId', 'configId'],
  deleteRecordText: "You are about to delete the external link. Do you still want to proceed?",
  fields: [
    {
      attributeName: 'icon',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      type: FormInputTypes.DOWNLOADABLE,
      hasSelect:false,
      label: 'Icon',
      helpText: 'Icon to identify this section.',
      placeholder: 'Select an icon...',
      fileType: ['.png'],
    },
    {
      attributeName: 'name',
      label: 'Tittle',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the link.',
    },
    {
      attributeName: 'subtitle',
      label: 'Subtitle',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the link.',
    },
    {
      attributeName: 'url',
      label: 'URL',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'URL of the link.',
    },
  ],
};